import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useInfiniteScrollQuery } from 'hooks'

import { useUpdateFollowRequestMutation } from 'store/api/yay/user'

import { UserList } from 'components'
import Button from 'components/Button'

import './style.scss'

const UserFollowRequestList = () => {
  const { t } = useTranslation()
  const memoArg = useMemo(() => ({}), [])

  const { loadMore, shouldLoadMore, combinedResults, latestQuery, isLoading } =
    useInfiniteScrollQuery({
      queryName: 'getFollowRequestList',
      memoArg,
      dataKey: 'users',
      paginationKeyName: 'fromTimestamp',
    })
  const [updateFollowRequest] = useUpdateFollowRequestMutation()

  return (
    <UserList
      users={combinedResults || []}
      onLoadMore={() => loadMore(latestQuery?.data?.last_timestamp)}
      isLoading={isLoading}
      showLoadMore={shouldLoadMore}
      followFrom="follower_list"
      actionButton={(user) => {
        return (
          <div className="UserFollowRequestList__action_button">
            <Button
              buttonStyle="bordered-green"
              icon="check-green"
              onClick={() =>
                updateFollowRequest({ userId: user?.id, action: 'accept' })
              }
              bold
            >
              {t('common.approve')}
            </Button>

            <Button
              buttonStyle="bordered-red"
              icon="x"
              onClick={() =>
                updateFollowRequest({ userId: user?.id, action: 'reject' })
              }
              bold
            >
              {t('common.decline')}
            </Button>
          </div>
        )
      }}
    />
  )
}

export default UserFollowRequestList
